import {
  CaretDownIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Radio,
  usePopoverContext,
} from '@tovala/component-library'
import { track } from 'utils/analytics'
import { events } from 'analytics/events'
import { getSelectedMealFiltersMetadata } from 'utils/menus'

const MealSort = ({
  menuSortOptions,
  selectedMealSort,
  onChangeSelectedMealSort,
  userID,
}: {
  menuSortOptions: { displayTitle: string; key: string }[]
  selectedMealSort: string | null
  onChangeSelectedMealSort(sortOption: string): void
  userID: number
}) => {
  if (menuSortOptions.length === 0) {
    return null
  }

  const selectedMealSortDetails = menuSortOptions.find(({ key }) =>
    selectedMealSort === null ? 'featured' : key === selectedMealSort,
  )

  return (
    <div className="z-5 relative mx-auto max-w-menu text-k/16_125 lg:px-4 md:px-0 md:pl-4">
      <Popover offset={4} placement="bottom-start" popoverStyle="white">
        <PopoverTrigger>
          <span className="flex items-center space-x-2 whitespace-nowrap">
            <span>Sort by:</span>
            <span className="text-orange-2 underline">
              {selectedMealSortDetails?.displayTitle}
            </span>
            <span className="block w-3.5 text-orange-2">
              <CaretDownIcon />
            </span>
          </span>
        </PopoverTrigger>

        <PopoverContent className="z-5">
          <MealSortOptions
            menuSortOptions={menuSortOptions}
            onChangeSelectedMealSort={onChangeSelectedMealSort}
            selectedMealSortDetails={selectedMealSortDetails}
            userID={userID}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}

export default MealSort
const MealSortOptions = ({
  menuSortOptions,
  onChangeSelectedMealSort,
  selectedMealSortDetails,
  userID,
}: {
  menuSortOptions: { displayTitle: string; key: string }[]
  onChangeSelectedMealSort(sortOption: string): void
  selectedMealSortDetails: { displayTitle: string; key: string } | undefined
  userID: number
}) => {
  const { setOpen } = usePopoverContext()

  return (
    <div className="min-w-[300px] divide-y divide-grey-3">
      {menuSortOptions.map(({ displayTitle, key }) => {
        const isSelected = selectedMealSortDetails
          ? selectedMealSortDetails.key === key
          : false
        return (
          <div key={key} className="flex items-center justify-between pr-4">
            <Radio
              checked={isSelected}
              id={key}
              label={<span className="inline-block p-4">{displayTitle}</span>}
              labelPosition="left"
              name={key}
              onChange={() => {
                onChangeSelectedMealSort(key)
                setOpen(false)

                const { enabled_filters, enabled_filters_count } =
                  getSelectedMealFiltersMetadata({ userID })

                track(events.CHANGES_SORT, {
                  sort_order: key,
                  enabled_filters,
                  enabled_filters_count,
                })
              }}
            />
          </div>
        )
      })}
    </div>
  )
}
